const onNavClick = function onMlpNavLinkClick(ev) {
  ev.preventDefault();
  const anchor = ev.currentTarget.getAttribute('data-section');
	const targetSection = anchor ? document.querySelector(`.${anchor}`) : "";
  if(targetSection) {
    targetSection.scrollIntoView({
      behavior: 'smooth', // Defines the transition animation. default: auto
      block: 'nearest', // Defines vertical alignment. "start|center|end|nearest" default: start
      inline: 'start' // Defines horizontal alignment. "start|center|end|nearest" default: nearest
    });
  }
}

const bind = function bindMlpNavInfo() {
	// [].forEach.call(
  //   document.querySelectorAll('.js-mlp-link'),
  //   (el) => {
  //     el.addEventListener('click', onNavClick);
  //   },
  // );
}

const init = function initMlpNavInfo() {
	bind();
}

const destroy = function destroyMlpNav() {
	// [].forEach.call(
  //   document.querySelectorAll('.js-mlp-link'),
  //   (el) => {
  //     el.removeEventListener('click', onNavClick);
  //   },
  // );
}

export default {
	init,
	destroy,
};
